import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularXmlEditorComponent } from './angular-xml-editor.component';
import { XmlEditorToolbarComponent } from './components/xml-editor-toolbar/xml-editor-toolbar.component';
import { XmlEditorAttributeEditorComponent } from './components/xml-editor-attribute-editor/xml-editor-attribute-editor.component';
import { XmlEditorDebugComponent } from './components/xml-editor-debug/xml-editor-debug.component';
import { DomBreakcrumbComponent } from './components/dom-breakcrumb/dom-breakcrumb.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  declarations: [AngularXmlEditorComponent, XmlEditorToolbarComponent, XmlEditorAttributeEditorComponent, XmlEditorDebugComponent, DomBreakcrumbComponent],
  exports: [AngularXmlEditorComponent, XmlEditorToolbarComponent, XmlEditorAttributeEditorComponent, XmlEditorDebugComponent, DomBreakcrumbComponent]
})
export class AngularXmlEditorModule {}
